// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plugins-management {
  padding: 20px 0;
}

.plugin-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0;
  height: 100%;
  transition: all 0.3s ease;
  overflow: hidden;
}

.plugin-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.plugin-card.active {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.plugin-header {
  background: #f8f9fa;
  padding: 20px;
  text-align: center;
  position: relative;
}

.plugin-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.plugin-badges {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.plugin-body {
  padding: 20px;
  min-height: 200px;
}

.plugin-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.plugin-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.5;
}

.plugin-price {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-value {
  font-size: 18px;
  font-weight: 600;
  color: #28a745;
}

.plugin-dependencies {
  margin-bottom: 10px;
  font-size: 13px;
}

.plugin-dependencies span {
  color: #666;
  font-style: italic;
}

.plugin-expiry {
  margin-bottom: 10px;
  font-size: 13px;
}

.plugin-expiry span {
  color: #dc3545;
  font-weight: 500;
}

.plugin-footer {
  background: #f8f9fa;
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.badge {
  font-size: 11px;
  padding: 4px 8px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.badge svg {
  font-size: 14px;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .plugin-card {
    margin-bottom: 15px;
  }
  
  .plugin-badges {
    position: static;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Plugins/PluginsManagement.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;AACF","sourcesContent":[".plugins-management {\n  padding: 20px 0;\n}\n\n.plugin-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 0;\n  height: 100%;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.plugin-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.plugin-card.active {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.plugin-header {\n  background: #f8f9fa;\n  padding: 20px;\n  text-align: center;\n  position: relative;\n}\n\n.plugin-icon {\n  font-size: 48px;\n  margin-bottom: 10px;\n}\n\n.plugin-badges {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.plugin-body {\n  padding: 20px;\n  min-height: 200px;\n}\n\n.plugin-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.plugin-description {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n\n.plugin-price {\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.price-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #28a745;\n}\n\n.plugin-dependencies {\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.plugin-dependencies span {\n  color: #666;\n  font-style: italic;\n}\n\n.plugin-expiry {\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.plugin-expiry span {\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.plugin-footer {\n  background: #f8f9fa;\n  padding: 15px 20px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.badge {\n  font-size: 11px;\n  padding: 4px 8px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.badge svg {\n  font-size: 14px;\n}\n\n.badge-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .plugin-card {\n    margin-bottom: 15px;\n  }\n  \n  .plugin-badges {\n    position: static;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
